import {
  SiteIncidentComment,
  CreateSiteIncidentCommentRequest,
} from '../models/SiteIncidentComment';
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';
import {
  ApiItemResponse,
  ApiListResponse,
  ApiOkResponse,
  ensureOk,
  unwrapItem,
  unwrapList,
} from './api/response';

/**
 * 장애 이력 게시물의 댓글 API 클라이언트.
 * - list(incidentId): 작성순(오래된 → 최신) 정렬된 댓글 배열
 * - create: body 가 공백이면 백엔드에서 400. 호출자는 trim 후 호출 권장.
 * - delete: admin 권한 필요
 */
export class SiteIncidentCommentService {
  static async list(incidentId: number): Promise<SiteIncidentComment[]> {
    const res = await apiClient.get<ApiListResponse<SiteIncidentComment>>(
      API_ENDPOINTS.SITE_MANAGEMENT.INCIDENTS.COMMENTS.LIST(incidentId),
    );
    return unwrapList(res, '댓글 목록 조회 실패');
  }

  static async create(
    incidentId: number,
    payload: CreateSiteIncidentCommentRequest,
  ): Promise<SiteIncidentComment> {
    const res = await apiClient.post<ApiItemResponse<SiteIncidentComment>>(
      API_ENDPOINTS.SITE_MANAGEMENT.INCIDENTS.COMMENTS.CREATE(incidentId),
      payload,
    );
    return unwrapItem(res, '댓글 작성 실패');
  }

  static async delete(commentId: number): Promise<void> {
    const res = await apiClient.delete<ApiOkResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.INCIDENTS.COMMENTS.DELETE(commentId),
    );
    ensureOk(res, '댓글 삭제 실패');
  }
}
